module.exports = __webpack_public_path__ + "img/why-quickcv-image-free-it@2x.36f090a5.png";